module.exports = __webpack_public_path__ + "img/image11.bd5584f7.png";